import { Trans } from 'react-i18next';

import clsx from 'clsx';

import { type TTranslateKey } from '@/types/i18n';

import { useStyles } from './MarketingText.styles';
import type { TMarketingText } from './types';

const MarketingText = ({
  label,
  name,
  className = '',
  gradient = false,
  style,
}: TMarketingText) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.marketingText, {
        [classes.gradient]: gradient,
        [className]: Boolean(className),
      })}
      style={style}
    >
      <Trans<TTranslateKey> i18nKey={label} values={{ name }} />
    </div>
  );
};

export default MarketingText;
